import AxiosAPI from '../../utils/AxiosAPI';

export const ApiDashboardInitial = () =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/dashboard`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Statistics of Subscription sales
export const ApiDBSalesSubscriptionStatistics = (formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/dashboard/sales-by-subscription`, {
                ...formData
            })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Statistics of Subscription sales
export const ApiDBSalesServiceStatistics = (formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/dashboard/sales-by-service`, {
                ...formData
            })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Statistics of application
export function ApiDBOverallStatistics(formData) {
    return new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/dashboard/overall-statistics`, {
                ...formData
            })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
}

// Products of subscriptions
export const ApiDashboardProductsSubscription = (formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/dashboard/subscriptions-by-applications`, {
                ...formData
            })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
export default null;
